import { FC } from 'react';

const HomePage: FC = () => {
    return (
        <>
            <hr />
            <h1>HomePage</h1>
            <hr />
        </>
    );
};

export default HomePage;
